// src/pages/LoginPage.tsx
import React from 'react';
import '../Styles/LoginPage.css';

const LoginPage: React.FC = () => {
  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Welcome to DigiRay</h1>
        <p>Log in or create an account to get started.</p>
        
        <div className="auth-options">
          <button className="auth-btn active">Login</button>
          <button className="auth-btn">Register</button>
        </div>

        <form className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input 
              type="email" 
              id="email" 
              placeholder="enter@your.email" 
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input 
              type="password" 
              id="password" 
              placeholder="••••••••" 
            />
            <a href="#" className="forgot-password">Forgot Password?</a>
          </div>
          
          <button type="submit" className="submit-btn">Login</button>
        </form>

        <div className="divider">or</div>
        
        <button className="anonymous-btn">Continue with Anonymous Login</button>
        
        <div className="made-with">
          Made with <span>Visily</span>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;